import { forwardRef, type HTMLAttributes, type ForwardedRef, type ReactNode } from 'react';
import { cn } from '../lib/cn';

export interface PanelShellProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  hideHeader?: boolean;
  title?: ReactNode;
  subtitle?: ReactNode;
  right?: ReactNode;
}

export const PanelShell = forwardRef(function PanelShell(
  { className, hideHeader = false, title, subtitle, right, children, ...props }: PanelShellProps,
  ref: ForwardedRef<HTMLElement>,
) {
  return (
    <section
      ref={ref}
      className={cn(
        'flex h-full min-h-0 flex-col overflow-hidden rounded-lg border border-border bg-card',
        className,
      )}
      {...props}
    >
      {hideHeader ? null : (
        <div className="flex h-11 shrink-0 items-center justify-between gap-3 border-b border-border px-3">
          <div className="min-w-0">
            {title ? (
              <h2 className="truncate text-[13px] font-semibold text-foreground">{title}</h2>
            ) : null}
            {subtitle ? (
              <p className="mt-0.5 truncate font-mono text-[10px] uppercase tracking-[0.12em] text-muted-foreground">
                {subtitle}
              </p>
            ) : null}
          </div>
          {right ? <div className="shrink-0">{right}</div> : null}
        </div>
      )}
      {children}
    </section>
  );
});
